module.exports = __webpack_public_path__ + "static/media/tray15.138bb99a.png";